import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/index.scss' // 重置样式
import element from 'element-plus'
import 'element-plus/theme-chalk/el-message.css'
import 'element-plus/theme-chalk/el-loading.css'
import 'element-plus/theme-chalk/el-message-box.css'
import * as ElIcons from '@element-plus/icons-vue'
import { vLoading } from 'element-plus/es/components/loading/src/directive'
import 'dayjs/locale/zh-cn' //中文
import locale from 'element-plus/lib/locale/lang/zh-cn' //中文
import '@/mockjs/mockjs.js'

const app = createApp(App)

app.directive('load', vLoading)

for (const name in ElIcons) {
  app.component(name, (ElIcons as any)[name])
}

app.use(store).use(router).use(element, { locale }).mount('#app')
